// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"244":"1cd14662","587":"3824520c","842":"3b462988"}[chunkId] + ".chunk.css";
};